module.exports = __webpack_public_path__ + "media/images/placeholders/highlight-thumbnail-a6ebeb52e55af10825cb63faad7a42ef.svg";